// extracted by mini-css-extract-plugin
export var container = "_s-1";
export var copyright = "_s-3";
export var footer = "_s-0";
export var logo = "_s-2";